/**
 * Centro de costo y porcentaje de viaje de la requisición (B1).
 *
 * Los dos son opcionales: dejarlos en blanco es una respuesta válida y no
 * traba el alta. Lo que sí se revisa es lo que alcanza a escribirse de más,
 * para que el aviso salga junto al campo y no como un 400 del servidor.
 *
 * Los topes son los mismos que valida el backend. Si se mueven allá y no aquí,
 * la persona choca contra un límite que la pantalla no menciona.
 */

export const MAXIMO_DEL_CENTRO_DE_COSTO = 100
export const MAXIMO_DEL_PORCENTAJE_DE_VIAJE = 100

/** El aviso del centro de costo, o null si está bien. */
export function avisoDelCentroDeCosto(valor: unknown): string | null {
  if (typeof valor !== 'string') return null

  return valor.trim().length > MAXIMO_DEL_CENTRO_DE_COSTO
    ? `El centro de costo no puede pasar de ${MAXIMO_DEL_CENTRO_DE_COSTO} caracteres`
    : null
}

/**
 * El aviso del porcentaje de viaje, o null si está bien.
 *
 * El campo vacío pasa: es opcional. El cero también, y no es lo mismo —cero es
 * «este puesto no viaja» y vacío es «no lo capturaron»—, así que la
 * comparación va contra null y undefined, no contra lo que sea falsy.
 */
export function avisoDelPorcentajeDeViaje(valor: unknown): string | null {
  if (valor === null || valor === undefined || valor === '') return null

  const numero = typeof valor === 'string' ? Number(valor.trim()) : valor

  if (typeof numero !== 'number' || !Number.isFinite(numero)) {
    return 'El porcentaje de viaje debe ser un número'
  }

  if (!Number.isInteger(numero)) {
    return 'El porcentaje de viaje no lleva decimales'
  }

  if (numero < 0) return 'El porcentaje de viaje no puede ser negativo'

  return numero > MAXIMO_DEL_PORCENTAJE_DE_VIAJE
    ? `El porcentaje de viaje no puede pasar de ${MAXIMO_DEL_PORCENTAJE_DE_VIAJE}`
    : null
}
